import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 排行榜java
interface AllRankGamesData {
  clientTime: string;
  gameType: number;
  type: number;
  page: number;
  size: number;
}

export const allRankGames = (json: AllRankGamesData): any =>
  http.httpPost({
    url: httpApi.homes.allRankGames,
    json,
  });

// 获取ios下载key
export const getIosAppKeyApi = (): any =>
  http.httpPost({
    url: httpApi.homes.getIosAppKey,
  });

// 获取盒子下载链接
interface GetDownUrlData {
  channel_type: number,
  device: string,
  channel_code: string,
}

export const getDownUrl = (json: GetDownUrlData): any => http.httpPost({
  url: httpApi.homes.getDownUrl,
  json,
})
